import * as types from './types';

const INITIAL_STATE = {
  sitesInfo: [],
  teachersInfo: [],
  reportLoading: false,
  fieldLoading: false,
  reports: [],
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.GET_SITES:
      return { ...state, sitesInfo: action.payload.data };
    case types.GET_TEACHERS:
      return { ...state, teachersInfo: action.payload.data };
    case types.TEACHER_REPORT_LOAD:
      return { ...state, reportLoading: action.payload };
    case types.TEACHERS_LOAD:
      return { ...state, fieldLoading: action.payload };
    case types.GET_TEACHERS_REPORT:
      return { ...state, reports: action.payload.data.Data };
    case types.CLEAR_REPORT_DATA:
      return { ...state, reports: [] };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/pages/teacherrolls/state/reducer.js